import { useNavigate } from "react-router-dom";
import EditableText from "../ui/EditableText";

export interface OfficeButton {
  src: string;
  label: string;
  path?: string;
}

export interface OfficeInput {
  label: string;
  subtitle?: string;
  text?: string;
  button?: OfficeButton | null;
}

const defaultOffices: OfficeInput[] = [
  {
    label: "MARKE | DESIGN",
    text: "Nullam at elit ac erat varius feugiat. Lorem ipsum dolor sit amet, consectetur.",
    button: {
      src: "/images/btn-read-more.svg",
      label: "Read more",
      path: "/trademark",
    },
  },
  {
    label: "PATENT",
    text: "Nullam at elit ac erat varius feugiat. Lorem ipsum dolor sit amet, consectetur.",
    button: {
      src: "/images/btn-read-more.svg",
      label: "Read more",
      path: "/patent",
    },
  },
  {
    label: "TRADEMARK | DESIGN | PATENT",
    text: "Nullam at elit ac erat varius feugiat. Lorem ipsum dolor sit amet, consectetur.",
    button: {
      src: "/images/btn-read-more.svg",
      label: "Read more",
      path: "/trademark",
    },
  },
];

interface RegistrationOfficesSectionProps {
  offices?: OfficeInput[];
  heading?: string;
  subtitle?: string;
  editable?: boolean;
  onSaveHeading?: (value: string) => void;
  onSaveSubtitle?: (value: string) => void;
  onSaveOfficeLabel?: (index: number, value: string) => void;
  onSaveOfficeText?: (index: number, value: string) => void;
  onSaveOfficeSubtitle?: (index: number, value: string) => void;
}

export default function RegistrationOfficesSection({
  offices = defaultOffices,
  heading = "REGISTRATION OFFICES",
  subtitle,
  editable = false,
  onSaveHeading,
  onSaveSubtitle,
  onSaveOfficeLabel,
  onSaveOfficeText,
  onSaveOfficeSubtitle,
}: RegistrationOfficesSectionProps) {
  const navigate = useNavigate();

  return (
    <section className="bg-white px-4 py-12 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto w-11/12 border-t border-dantzBlue" />

        <EditableText
          as="h2"
          value={heading}
          editMode={editable}
          onSave={(value) => onSaveHeading?.(value)}
          className="mb-3 mt-10 block text-center text-[28px] font-light tracking-widest text-dantzBlue"
        />

        {subtitle ? (
          <EditableText
            as="p"
            value={subtitle}
            editMode={editable}
            onSave={(value) => onSaveSubtitle?.(value)}
            className="mb-10 text-center text-base font-medium tracking-wide text-dantzBlue"
          />
        ) : (
          <div className="mb-10" />
        )}

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {offices.map((office, index) => (
            <div key={index} className="relative flex min-h-40 flex-col justify-between md:px-6">
              {index > 0 && (
                <div className="absolute left-0 top-1 hidden h-full w-px bg-dantzBlue md:block" />
              )}

              {editable ? (
                <EditableText
                  as="h3"
                  value={office.label}
                  editMode
                  onSave={(value) => onSaveOfficeLabel?.(index, value)}
                  className="font-heading text-[26px] font-normal tracking-wide text-dantzBlue"
                />
              ) : (
                <h3 className="font-heading text-[26px] font-normal tracking-wide text-dantzBlue">
                  {office.label}
                </h3>
              )}


              {office.subtitle && (
                editable ? (
                  <EditableText
                    as="p"
                    value={office.subtitle}
                    editMode
                    onSave={(value) => onSaveOfficeSubtitle?.(index, value)}
                    className="font-heading mt-1 text-[16px] font-medium tracking-wide text-dantzBlue"
                  />
                ) : (
                  <p className="font-heading mt-1 text-[16px] font-medium tracking-wide text-dantzBlue">
                    {office.subtitle}
                  </p>
                )
              )}

              {office.text && (
                editable ? (
                  <EditableText
                    as="p"
                    value={office.text}
                    editMode
                    onSave={(value) => onSaveOfficeText?.(index, value)}
                    className="font-heading mt-2 text-sm font-normal text-gray-600"
                  />
                ) : (
                  <p className="font-heading mt-2 text-sm font-normal text-gray-600">{office.text}</p>
                )
              )}

              {office.button && (
                <button
                  onClick={() => navigate(office.button!.path ?? "/register")}
                  className="mt-5 block"
                  aria-label={office.button.label}
                >
                  <img src={office.button.src} alt={office.button.label} className="h-9 w-auto" />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
